import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pdf-split-toolbar-button',
  templateUrl: './pdf-split-toolbar-button.component.html',
  styleUrls: ['./pdf-split-toolbar-button.component.css']
})
export class PdfSplitToolbarButtonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
